export enum PaymentMethodType {
  GMO = 'creaditcard',
  Paypal = 'paypal',
}
